cartBase = {
  options: {
    freeGifts: null,
    cookieKey: 'discount_code',
    message: document.querySelector('[data-free-gift-message]'),
  },
  init: function () {
    var self = this;

    this.$cart = jQuery('[data-cart]');

    // Track items changed
    self.itemsChanged = 0;

    // Skip if options are missing
    if (typeof freeGifts === 'undefined') {
      return;
    }

    // Skip if not on cart page
    if (window.location.pathname !== '/cart') {
      return;
    }

    // Get options from settings
    self.options.freeGifts = freeGifts.map(self.parseThemePromotion);

    console.log(self.options.freeGifts)

    // Get discount code from cookie
    var discountCode = Cookies.get(self.options.cookieKey)

    jQuery('input[data-summary-discount]').val(discountCode);

    if (self.validDiscount(discountCode)) {
      if (self.options.message !== null && self.options.message.classList.contains('hidden')) {
        self.options.message.classList.remove('hidden');
      }
      jQuery(document).scrollTop(0);
    }

    // Validate on page load
    self.validateFreeGift();

    $('body').on('click', '[data-cart-item-remove]', function(){
      $('[name="checkout"]').attr("disabled","disabled");
    });

    jQuery(document).on('click', '[data-discount-apply]', function() {
      if (jQuery('input[data-summary-discount]').val() === "") {
        Cookies.remove(self.options.cookieKey);
      }
      self.validateFreeGift();
    });

    this.$cart.on('cart:update', function() {
      self.validateFreeGift();
    });
  },

  parseThemePromotion(input) {
    promotion = {};
    promotion.threshold = input.threshold;
    promotion.product_incart_handle = input.product_incart_handle;
    promotion.codes = null;
    if (input.codes !== null && input.codes !== '') {
      promotion.codes = input.codes.split(',').map(i => i.toLowerCase().trim());
    }
    promotion.variant_ids = input.variant_ids.split(',').map(i => i.trim());
    return promotion;
  },

  validateFreeGift: function() {
    var self = this,
        $discountCode = jQuery('input[data-summary-discount]')

    if ($discountCode.length < 1) return

    var discountCode = $discountCode.val().toLowerCase(),
        allowedCodes = this.options.allowedCodes;

    // Get the current cart
    jQuery.ajax({
      url: '/cart.js',
      method: 'GET',
      dataType: 'json'
    }).then(function(cart) {
      var totalQty = 0;
      var itemIds = jQuery.map(cart.items, function(item) {
        totalQty += item.quantity;
        return item.id;
      });

      var freeItems = self.validDiscount(discountCode, cart).map(Number);
      Cookies.set(self.options.cookieKey, discountCode);

      var diff = jQuery(itemIds).not(freeItems).get();
      if (itemIds.length != (diff.length + freeItems.length)){
        freeItems.forEach(freeItem => {
          if(jQuery.inArray(freeItem, itemIds) < 0){
            self.addGift(freeItem)
          }
        });
      } else if (itemIds.sort().join(',') === freeItems.sort().join(',') && totalQty == freeItems.length) {
        Cookies.remove(self.options.cookieKey);
        itemIds.forEach(itemId => {
          cart.items.forEach(item => {
            if(itemId == item.id){
              if(item.quantity == 1){
                self.removeGift(itemId);
              }
            }
          });
        });
      } else if (freeItems == 0 && totalQty > 0 && cart.total_price == 0){
        cart.items.forEach(item => {
          if(item.quantity == 1){
            self.removeGift(item.id);
          }
        });
      } else {
        // last line of defense if an item in the cart is 0.00 and there is not supposed to be any free items in the cart
        cart.items.forEach(item => {
          if(item.price == 0 && (freeItems.length == 0 || freeItems.indexOf(item.id) < 0)){
            self.removeGift(item.id);
          }
        });
      }

      // Remove any coded gifts when discount code is empty
      if (discountCode === "") {
        jQuery.each(self.options.freeGifts, function (i, item) {
          var freeItems = item.variant_ids;
          freeItems.forEach(freeItem => {
            if (item.codes !== null && itemIds.indexOf(freeItem) > -1) {
              // Remove gift if discount code removed
              Cookies.remove(self.options.cookieKey);
              self.removeGift(freeItem);
            }
          });
        });
      }
      if(self.itemsChanged > 0){
        window.location.reload();
      }
    });
  },

  validDiscount: function (discountCode, cart) {
    var self = this,
        freeItems = [];

    jQuery.each(this.options.freeGifts, function (i, item) {
      if (discountCode === "" && item.codes === null && item.threshold === null && item.product_incart_handle === null) {
        // Match basic free gifts
        freeItems = freeItems.concat(item.variant_ids);
      } else if (item.codes !== null && item.codes.indexOf(discountCode) > -1 && self.validThreshold(item, cart) && self.validProductInCart(item, cart)) {
        // Match free gift with codes
        freeItems = freeItems.concat(item.variant_ids);
      } else if (cart && item.codes == null && self.validThreshold(item, cart) && self.validProductInCart(item, cart)) {
        // Match with amount threshold and product in cart
        freeItems = freeItems.concat(item.variant_ids);
      }

    });

    if (typeof discountCode !== 'undefined' && discountCode !== "") {
      jQuery('[data-discount-applied-label]').removeClass('hidden')
      jQuery('[data-discount-applied]').text(discountCode)
      jQuery('[data-discount-applied]').removeClass('hidden')
    }

    return freeItems;
  },

  validProductInCart: function (item, cart) {
    if (cart) {
      if (item.product_incart_handle === null) {
        return true;
      }

      var productHandles = jQuery.map(cart.items, function(item) {
        return item.handle;
      });
      if (productHandles.indexOf(item.product_incart_handle) > -1) {
        return true;
      }
    }
    return false;
  },

  validThreshold: function (item, cart) {
    if (cart) {
      return item.threshold === null || (item.threshold !== null && cart.total_price >= (item.threshold * 100));
    }
    return false;
  },

  addGift: function (freeItem) {
    var self = this;
    jQuery.ajax({
      url: '/cart/add.js',
      method: 'POST',
      dataType: 'json',
      data: {
        id: freeItem,
        quantity: 1
      },
      async: false,
      success: function(data){
        self.itemsChanged++
      },
      error: function(data){
        return false;
      }
    });
  },

  removeGift: function(freeItem) {
    var self = this;

    jQuery.ajax({
      url: '/cart/change.js',
      method: 'POST',
      dataType: 'json',
      data: {
        id: freeItem,
        quantity: 0
      },
      async: false,
      success: function(data) {
        self.itemsChanged++
      }
    });
  }
}

jQuery(function () {
  cartBase.init();
});
